/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type PreferredDesignersListQueryVariables = Types.Exact<{
    page?: Types.Maybe<Types.Scalars['Int']>;
    pageSize?: Types.Maybe<Types.Scalars['Int']>;
}>;

export type PreferredDesignersListQuery = {
    __typename: 'Query';
    myDesigners: {
        __typename: 'MyDesignersResponse';
        designers: Array<{
            __typename: 'DesignerSummary';
            userCanonicalId: string;
            user: Types.Maybe<{
                __typename: 'User';
                displayName: string;
                profile: { __typename: 'Profile'; avatarUrl: string };
            }>;
        }>;
    };
};

export const PreferredDesignersListDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'PreferredDesignersList' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'pageSize' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myDesigners' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'page' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'page' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'pageSize' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'pageSize' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'designers' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'userCanonicalId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'user' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'displayName',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'profile',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'avatarUrl',
                                                                        },
                                                                        arguments: [
                                                                            {
                                                                                kind: 'Argument',
                                                                                name: {
                                                                                    kind: 'Name',
                                                                                    value: 'size',
                                                                                },
                                                                                value: {
                                                                                    kind: 'EnumValue',
                                                                                    value: 'S',
                                                                                },
                                                                            },
                                                                        ],
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __usePreferredDesignersListQuery__
 *
 * To run a query within a React component, call `usePreferredDesignersListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreferredDesignersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreferredDesignersListQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function usePreferredDesignersListQuery(
    baseOptions?: Apollo.QueryHookOptions<
        PreferredDesignersListQuery,
        PreferredDesignersListQueryVariables
    >
) {
    return Apollo.useQuery<PreferredDesignersListQuery, PreferredDesignersListQueryVariables>(
        PreferredDesignersListDocument,
        baseOptions
    );
}
export function usePreferredDesignersListLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        PreferredDesignersListQuery,
        PreferredDesignersListQueryVariables
    >
) {
    return Apollo.useLazyQuery<PreferredDesignersListQuery, PreferredDesignersListQueryVariables>(
        PreferredDesignersListDocument,
        baseOptions
    );
}
export type PreferredDesignersListQueryHookResult = ReturnType<
    typeof usePreferredDesignersListQuery
>;
export type PreferredDesignersListLazyQueryHookResult = ReturnType<
    typeof usePreferredDesignersListLazyQuery
>;
export type PreferredDesignersListQueryResult = Apollo.QueryResult<
    PreferredDesignersListQuery,
    PreferredDesignersListQueryVariables
>;
